/**
 * Sort helpers for email_inbox_log rows on admin inbox review.
 * Uses the same instant as the "when" display: received_at, else created_at.
 *
 * @see docs/APP_UI_SPEC.md — D1
 */

export function inboxRowChronologicalMs(row) {
  const t = row.received_at || row.created_at;
  if (!t) return Number.NEGATIVE_INFINITY;
  const ms = new Date(t).getTime();
  return Number.isNaN(ms) ? Number.NEGATIVE_INFINITY : ms;
}

export function sortInboxRowsReverseChronological(rows) {
  return [...(rows || [])].sort(
    (a, b) => inboxRowChronologicalMs(b) - inboxRowChronologicalMs(a)
  );
}
